import { render, staticRenderFns } from "./floating-alert.vue?vue&type=template&id=e8137a70&scoped=true"
import script from "./floating-alert.ts?vue&type=script&lang=ts&external"
export * from "./floating-alert.ts?vue&type=script&lang=ts&external"
import style0 from "./floating-alert.vue?vue&type=style&index=0&id=e8137a70&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8137a70",
  null
  
)

export default component.exports